import { ErrorBoundary, Notifications, Skeleton, SkeletonHeader } from '@isbj-redesign/shared-components'
import React, { FC } from 'react'
import Footer from '../Footer'

export type LayoutProps = {
    title: string
}

const BrowserCheckLayout: FC<LayoutProps> = ({ title, children }) => {
    return (
        <Skeleton fachkontext="Dokumententresor" title={<Title title={title} />} links={{}}>
            <ErrorBoundary>{children}</ErrorBoundary>
            <Footer />
        </Skeleton>
    )
}

const Title = ({ title }: LayoutProps) => (
    <>
        <SkeletonHeader title={title} />
        <Notifications />
    </>
)

export default BrowserCheckLayout
